import { TableCell, TableRow } from '@material-ui/core';
import React, { Component } from 'react';
import { getProject } from '../../../common/services/project';
import { SourceChip } from '../components/MatchVideoCard.component';
import { formatDuration, getPreviewThumbnail, IMatchVideo } from '../typings';

interface IProps {
  tableData: IMatchVideo;
}

export class MatchVideoRow extends Component<IProps> {
  public render() {
    const { tableData: video } = this.props;
    const match = video.match as any;
    const thumbnail = getPreviewThumbnail(video);
    const href = `#${getProject().url}/match-videos/${video.id}`;

    return (
      <TableRow hover href={href} component="a">
        <TableCell style={{ width: 112 }}>
          {thumbnail && <img src={thumbnail.url} alt="" style={{ width: 96, display: 'block', borderRadius: 2 }} />}
        </TableCell>
        <TableCell>
          {match ? (
            <>
              <strong>{match.description || `${match.homeTeam ? match.homeTeam.name : '?'} vs ${match.awayTeam ? match.awayTeam.name : '?'}`}</strong>
              <br />
              {match.date ? new Date(match.date).toLocaleString() : '-'}
              <br />
              {match.phaseTournamentCompetitionName || '-'}
            </>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell>
          {video.title}
          <br />
          <span style={{ color: '#757575' }}>{video.originalTitle || '-'}</span>
        </TableCell>
        <TableCell>{formatDuration(video.duration)}</TableCell>
        <TableCell>
          <SourceChip source={video.metaImportSource} />
          {video.isEmbeddable === false && <span style={{ color: '#f44336', marginLeft: 8 }}>⚠</span>}
        </TableCell>
        <TableCell>{video.sourcePublishedAt ? new Date(video.sourcePublishedAt).toLocaleDateString() : '-'}</TableCell>
      </TableRow>
    );
  }
}
